var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbstract4(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 119,
    viewBox: "0 0 365 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.7885 65.9827C53.2489 55.8367 28.6385 0 28.6385 0L0 11.5119C5.89615 31.1663 20.7769 71.3175 28.6385 82.8294C34.9277 92.0389 73.5615 115.774 86.7577 120.734L164.25 130L251.008 120.734L307.442 109.222C315.865 105.385 335.014 96.1382 344.223 89.8488C353.432 83.5594 361.912 74.874 365 71.3175L344.223 50.54C331.588 71.3175 274.031 86.1987 241.742 89.8488C209.454 93.4989 102.762 88.1641 68.7885 65.9827Z",
    fill: "#D6C2FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract4);
export default __webpack_public_path__ + "static/media/abstract-4.312f7a008b1f20883a04398b6753e89b.svg";
export { ForwardRef as ReactComponent };